import { useEffect, useState } from "react";
import NfsDropdown from "../genericComponents/NfsDropdown/NfsDropdown";
import { GetCodedValueAndAlias } from "../../utils/arcgisUtils";
import type Graphic from "@arcgis/core/Graphic";

interface ResultsFilterProps {
    results: Graphic[];
    selectedSource: string | null;
    setSelectedSource: (source: string | null) => void;
    selectedStatus: string | null;
    setSelectedStatus: (status: string | null) => void;
    loading?: boolean;
}

const ResultsFilter = (props: ResultsFilterProps) => {
    const { results, selectedSource, setSelectedSource, selectedStatus, setSelectedStatus, loading } = props;

    const [searchSources, setSearchSources] = useState<string[]>([]);
    const [allStatuses, setAllStatuses] = useState<{ value: string | number; codedValue: string | number }[]>([]);

    useEffect(() => {
        // Group results by layer title and count results
        const layerMap = new Map<string, number>();
        for (const feature of results) {
            const layerTitle = feature.layer?.title;
            if (layerTitle) {
                layerMap.set(layerTitle, (layerMap.get(layerTitle) ?? 0) + 1);
            }
        }

        const selectedSearchSourceTitle = selectedSource?.split(" (")[0] ?? "";

        const sources = Array.from(layerMap.entries()).map(([title, count]) => `${title} (${count})`);
        setSearchSources(sources);

        for (const entry of layerMap.entries()) {
            if (entry[0] === selectedSearchSourceTitle) {
                setSelectedSource(`${entry[0]} (${entry[1]})`);
                break;
            }
        }
    }, [results]);

    useEffect(() => {
        if (loading) return;

        const selectedSearchSourceTitle = selectedSource?.split(" (")[0] ?? "";
        const searchSourcesTitles = searchSources.map((source) => source.split(" (")[0]);

        if (selectedSource && !searchSourcesTitles.includes(selectedSearchSourceTitle)) {
            setSelectedSource(null);
        }
    }, [loading]);

    useEffect(() => {
        const statusMap = new Map<string | number, { value: string | number; codedValue: string | number }>();
        for (const feature of results ?? []) {
            const statusValue = feature.attributes["nfs_status"] ?? "ingen status";
            const codedValue = GetCodedValueAndAlias(feature.layer, "nfs_status", statusValue)[1];
            statusMap.set(statusValue, { value: statusValue, codedValue });
        }
        // }
        setAllStatuses(Array.from(statusMap.values()));
    }, [selectedSource]);

    return (
        <div className="search-results-actions">
            <label className="auto-flex flex-col">
                Type:
                <NfsDropdown
                    options={searchSources}
                    selectedOption={selectedSource}
                    setSelectedOption={setSelectedSource}
                    placeholder="Alle"
                    allowEmpty
                    disabled={searchSources.length === 0}
                />
            </label>
            <label className="auto-flex flex-col">
                Status:
                <NfsDropdown
                    options={allStatuses.map((status) => status.codedValue as string)}
                    selectedOption={selectedStatus}
                    setSelectedOption={setSelectedStatus}
                    placeholder="Alle"
                    allowEmpty
                    disabled={allStatuses.length === 0}
                />
            </label>
        </div>
    );
};

export default ResultsFilter;
